<template>
  <div class="facture">
    <v-container fluid v-if="this.facture != null">

      <h1 class="text-center my-5">{{ titre(facture) }}</h1>

      <AlerteFacture v-if="showAlert" :facture="facture" />
      
      <InfosFacture :facture="this.facture" :formatDate="formatDate" class="mb-6" />

      <DetailsFacture :facture="this.facture" :formatPrix="formatPrix" :formatQuantite="formatQuantite" class="mb-6" />

      <PaiementFacture :solde="this.facture.solde" :inputFields="inputFields" :formatPrix="formatPrix" @payerClicked="payerClicked" v-if="facture.solde >= 0.01" class="mb-6">
        <template v-slot:btn-paiement><slot name="btn-paiement"></slot></template>
      </PaiementFacture>

    </v-container>
  </div>
</template>

<script>
import InfosFacture from "./InfosFacture"
import DetailsFacture from "./DetailsFacture"
import PaiementFacture from "./PaiementFacture"
import AlerteFacture from "./AlerteFacture"

export default {
  components: {
    InfosFacture,
    DetailsFacture,
    PaiementFacture,
    AlerteFacture
  },
    props: {
      facture: Object,
      inputFields: {
        type: Boolean,
        default: false
      },
      showAlert: {
        type: Boolean,
        default: true
      },
      titre: {
        type: Function,
        default: (facture) => {
          if(facture.solde > 0){
            return "Résumé de la facture " + facture.reference
          }
          return "Reçu de paiement de la facture " + facture.reference
        }
      },
      formatPrix: {
        type: Function,
        default: (montant) => {
          let val = (montant/1).toFixed(2).replace('.', ",")
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " $"
        }
      },
      formatDate: {
        type: Function,
        default: (date) => {
          var options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          }
          var locale = "fr-CA"
          return new Date(date).toLocaleString(locale, options)
        }
      },
      formatQuantite: {
        type: Function,
        default: (quantite) => {
          let val = (quantite/1).toFixed(0)
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        }
      }
    },
    methods:{
      payerClicked(carte){
        this.$emit('payerClicked', carte)
      }
    }
}
</script>

<style>

</style>